<template>
  <div
    id="office-calendars"
  >
    <div v-if="offices.length > 0">
      <TabView
        v-model:activeIndex="index"
        lazy
      >
        <TabPanel
          v-for="office in offices"
          :key="office.id"
          :header="office.name"
        >
          <OfficeCalendar
            :office="office"
            :appointments="selectedOfficeAppointments"
            :control-duration="controlDuration"
            @create-appointment="onCreateAppointment"
            @remove-appointment="onRemoveAppointment"
          />
        </TabPanel>
      </TabView>
    </div>
    <div v-else>
      <p>{{ $t('appointmentPage.noOffice') }}</p>
    </div>
  </div>
</template>

<script>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import OfficeCalendar from "@/components/appointments/OfficeCalendar";

export default {
  name: 'OfficeCalendarsTabView',
  components: {OfficeCalendar, TabView, TabPanel},
  props: {
    site: {
      type: Object,
      required: true
    },
    controlDuration: {
      type: Number,
      required: true
    },
    modelValue: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      offices: [],
      index: 0,
    }
  },
  computed: {
    appointments: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    selectedOffice() {
      return this.offices[this.index]
    },
    selectedOfficeAppointments() {
      return this.appointments.filter(appointment => {
        return appointment.office.id === this.selectedOffice.id;
      });
    }
  },
  mounted() {
    this.$watch('site', site => this.getOfficesBySite(site))
    this.getOfficesBySite(this.site)
  },
  methods: {
    async getOfficesBySite(site) {
      let params = {
        sitesId: site.id,
        enabled: true,
      }
      let offices = await this.$officeService.getAll(params)
      if (offices) {
        this.offices = offices.content
      }
    },
    onCreateAppointment(createdAppointment) {
      const appointments = [...this.appointments]
      appointments.push(createdAppointment)
      this.appointments = appointments
    },
    onRemoveAppointment(appointmentToRemove) {
      this.appointments = this.appointments.filter(appointment => {
        return appointment !== appointmentToRemove;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
#office-calendars {
  border: 2px solid #dee2e6;
}

::v-deep(.p-tabview ul.p-tabview-nav) {
  background-color: #fff;
  flex-flow: row wrap;
}
</style>

